/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const useDeletableThumbnailBadgeStyles = makeStyles(() => ({
  deleteIcon: {
    background: '#ECEBED',
  },
}));
